module.exports = __webpack_public_path__ + "img/9788952756749.9261788b.jpg";